/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckId } from './grundstueckId';
import { HistInfo } from './histInfo';
import { OrtschaftListEntry } from './ortschaftListEntry';


export interface GrundstueckadresseDetailEntry { 
    histInfo?: HistInfo;
    adressText?: string;
    grundstueckId?: GrundstueckId;
    ortschaft?: OrtschaftListEntry;
    lagebezeichnungsTyp?: GrundstueckadresseDetailEntry.LagebezeichnungsTypEnum;
}
export namespace GrundstueckadresseDetailEntry {
    export type LagebezeichnungsTypEnum = 'FLURNAME' | 'ORTSNAME' | 'STRASSE';
    export const LagebezeichnungsTypEnum = {
        FLURNAME: 'FLURNAME' as LagebezeichnungsTypEnum,
        ORTSNAME: 'ORTSNAME' as LagebezeichnungsTypEnum,
        STRASSE: 'STRASSE' as LagebezeichnungsTypEnum
    };
}


